import React from "react";
import Mapa from "../MapaUbicacionEmpresa/Mapa";

function MediosDeContacto() {
  return (

    <div>

      <div>

        <p>Telefono: 677 342 123</p>

        <p>Email: recoconstrucciones@gmail.com</p>

      </div>

      <div>

        <Mapa />

      </div>

    </div>
  )
}

export default MediosDeContacto;